import React from 'react';
import { UploadIcon, CheckCircleIcon } from 'lucide-react';
const DocumentUploadStep = ({
  onNext,
  onPrev
}) => {
  const handleSubmit = e => {
    e.preventDefault();
    onNext();
  };
  return <div data-id="element-695">
      <h2 className="text-xl font-semibold mb-6" data-id="element-696">Document Upload</h2>
      <p className="text-sm text-gray-500 mb-6" data-id="element-697">
        Please upload the following documents to verify your business and comply
        with regulations. All documents must be in PDF, JPG, or PNG format and
        under 5MB.
      </p>
      <form onSubmit={handleSubmit} data-id="element-698">
        <div className="space-y-6" data-id="element-699">
          <div className="border border-gray-200 rounded-md p-4" data-id="element-700">
            <h3 className="font-medium mb-2" data-id="element-701">
              Business Registration Certificate
            </h3>
            <p className="text-sm text-gray-500 mb-3" data-id="element-702">
              Upload your business registration certificate or incorporation
              documents.
            </p>
            <div className="border-2 border-dashed border-gray-300 rounded-md p-6 flex flex-col items-center" data-id="element-703">
              <UploadIcon className="h-8 w-8 text-gray-400 mb-2" data-id="element-704" />
              <p className="text-sm text-gray-500 mb-2" data-id="element-705">
                Drag and drop, or click to select file
              </p>
              <input type="file" className="hidden" id="business-registration" required data-id="element-706" />
              <button type="button" onClick={() => document.getElementById('business-registration').click()} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm" data-id="element-707">
                Select File
              </button>
            </div>
          </div>
          <div className="border border-gray-200 rounded-md p-4" data-id="element-708">
            <h3 className="font-medium mb-2" data-id="element-709">Tax Registration Certificate</h3>
            <p className="text-sm text-gray-500 mb-3" data-id="element-710">
              Upload your tax registration certificate or tax ID proof.
            </p>
            <div className="border-2 border-dashed border-gray-300 rounded-md p-6 flex flex-col items-center" data-id="element-711">
              <UploadIcon className="h-8 w-8 text-gray-400 mb-2" data-id="element-712" />
              <p className="text-sm text-gray-500 mb-2" data-id="element-713">
                Drag and drop, or click to select file
              </p>
              <input type="file" className="hidden" id="tax-registration" required data-id="element-714" />
              <button type="button" onClick={() => document.getElementById('tax-registration').click()} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm" data-id="element-715">
                Select File
              </button>
            </div>
          </div>
          <div className="border border-gray-200 rounded-md p-4" data-id="element-716">
            <h3 className="font-medium mb-2" data-id="element-717">Proof of Business Address</h3>
            <p className="text-sm text-gray-500 mb-3" data-id="element-718">
              Upload a utility bill or bank statement showing your business
              address (issued within the last 3 months).
            </p>
            <div className="border-2 border-dashed border-gray-300 rounded-md p-6 flex flex-col items-center" data-id="element-719">
              <UploadIcon className="h-8 w-8 text-gray-400 mb-2" data-id="element-720" />
              <p className="text-sm text-gray-500 mb-2" data-id="element-721">
                Drag and drop, or click to select file
              </p>
              <input type="file" className="hidden" id="address-proof" required data-id="element-722" />
              <button type="button" onClick={() => document.getElementById('address-proof').click()} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm" data-id="element-723">
                Select File
              </button>
            </div>
          </div>
          <div className="border border-gray-200 rounded-md p-4" data-id="element-724">
            <h3 className="font-medium mb-2" data-id="element-725">
              ID Proof of Business Owner/Director
            </h3>
            <p className="text-sm text-gray-500 mb-3" data-id="element-726">
              Upload a valid government ID (passport, driver's license, or ID
              card) of the business owner or director.
            </p>
            <div className="border-2 border-dashed border-gray-300 rounded-md p-6 flex flex-col items-center" data-id="element-727">
              <UploadIcon className="h-8 w-8 text-gray-400 mb-2" data-id="element-728" />
              <p className="text-sm text-gray-500 mb-2" data-id="element-729">
                Drag and drop, or click to select file
              </p>
              <input type="file" className="hidden" id="id-proof" required data-id="element-730" />
              <button type="button" onClick={() => document.getElementById('id-proof').click()} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm" data-id="element-731">
                Select File
              </button>
            </div>
          </div>
          <div className="pt-4 flex justify-between" data-id="element-732">
            <button type="button" onClick={onPrev} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-733">
              Back
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-734">
              Continue to Compliance Screening
            </button>
          </div>
        </div>
      </form>
    </div>;
};
export default DocumentUploadStep;